import {Injectable} from '@angular/core';
import {Observable, of, tap} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {EsriModuleService} from '../../design/esri-nlr/services/esri-module.service';
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class FeaturesRepositoryStore {
    title = 'Features Repository Store';

    private pristineFeatureClassMap = {
        angle: [],
        annotation: [],
        controlpoint: [],
        point: [],
        line: [],
        polygon: [],
        lot: [],
        affectedlot: [],
        road: [],
        constructpoint: [],
        constructline: [],
        interest: [],
        enlargement: [],
        clipping: [],
        polyline: [],
        printarea: []
    };

    private featureClassMap = {
        angle: [],
        annotation: [],
        controlpoint: [],
        point: [],
        line: [],
        polygon: [],
        lot: [],
        affectedlot: [],
        road: [],
        constructpoint: [],
        constructline: [],
        interest: [],
        enlargement: [],
        clipping: [],
        polyline: [],
        printarea: []
    };

    private featureClassMapKeys = Object.keys(this.featureClassMap);

    constructor(private esriModuleService: EsriModuleService) {}

    addFeatures(featureClass: string, features: any): Observable<any> {
        if (!features) {
            return of(null);
        }

        featureClass = featureClass.toLowerCase();

        let observable = of(null);

        if (featureClass === 'line') {
            const polylines = features.filter(f => f.attributes.pointids);
            if (polylines.length) {
                observable = observable.pipe(switchMap(() => this.addFeatures('polyline', polylines)));
            }
        }

        return observable.pipe(
            tap(() => {
                const featureIds = features.map((f: any) => f.attributes.id);
                const jsonFeatures = features.map((f: any) => (f.toJson ? f.toJson() : f));

                if (jsonFeatures.length === 0) {
                    return;
                }

                const featureClassFeatures = this.featureClassMap[featureClass];
                featureClassFeatures.splice(
                    0,
                    featureClassFeatures.length,
                    ...featureClassFeatures.filter((f: any) => !featureIds.includes(f.attributes.id)),
                    ...jsonFeatures.map((f: any) => new this.esriModuleService.Graphic(f))
                );

                this.setPristineFeatures(featureClass, featureClassFeatures);
            })
        );
    }

    clearFeatures(featureClass: string): void {
        if (this.featureClassMap[featureClass]) {
            this.featureClassMap[featureClass].length = 0;
            this.pristineFeatureClassMap[featureClass].length = 0;
        }
    }

    clearAllFeatures(): void {
        this.getFeatureClasses().forEach(k => this.clearFeatures(k));
    }

    getFeatureClasses(): string[] {
        return this.featureClassMapKeys;
    }

    getFeatureClassMap() {
        return this.featureClassMap;
    }

    getPristineFeatureClassMap() {
        return this.pristineFeatureClassMap;
    }

    stripClientAttrs(featureClass: string, feature: any): void {
        const attrs = feature.attributes;
        if (!attrs) return;

        if (typeof attrs.uniqueId === 'number') {
            delete attrs.uniqueId;
        }

        if (['angle', 'annotation'].includes(featureClass)) {
            ['attributeCustom', 'labelproperties'].filter(k => k in attrs).forEach(k => delete attrs[k]);
        }
    }

    setPristineFeatures(featureClass: string, features: any[]): void {
        const pristineFeatures = this.pristineFeatureClassMap[featureClass];
        pristineFeatures.splice(
            0,
            pristineFeatures.length,
            ...features.map(f => {
                const jsonFeature = f.toJson();
                this.stripClientAttrs(featureClass, jsonFeature);
                return jsonFeature;
            })
        );
    }
}
